import { useEffect, useState } from 'react';
import './PDFModal.scss';

const PDFModal = ({ isOpen, pdfFile, onClose, showTreeView = false }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [selectedPDF, setSelectedPDF] = useState(null);

  // Legal documents timeline structure matching the design
  const legalDocuments = [
    {
      id: 'quy-hoach-2000',
      title: 'QUY HOẠCH 1/2000',
      subtitle: '',
      date: '',
      position: 'bottom',
      pdf: {
        filename:
          '1. QĐ 4055 Phe duyet dieu chinh 1-2000 P.16 Q.8 ngay 26.07.2013.pdf',
        title: 'QĐ 4055 - Phê duyệt điều chỉnh 1/2000 P.16 Q.8',
      },
    },
    {
      id: 'chu-truong-dau-tu',
      title: 'CHẤP THUẬN CHỦ TRƯƠNG ĐẦU TƯ',
      subtitle: '',
      date: '',
      position: 'bottom',
      pdf: {
        filename: '3. QĐ 4396 Chap thuan chu truong dau tu ngay 04.10.2024.pdf',
        title: 'QĐ 4396 - Chấp thuận chủ trương đầu tư',
      },
    },
    {
      id: 'phe-duyet-ke-hoach',
      title: 'PHÊ DUYỆT KẾ HOẠCH PHÁT TRIỂN NHÀ Ở',
      subtitle: '',
      date: '',
      position: 'top',
      pdf: {
        filename:
          '2. QĐ 4151 Phe duyet ke hoach phat trien nha o 09.12.2021.pdf',
        title: 'QĐ 4151 - Phê duyệt kế hoạch phát triển nhà ở',
      },
    },
    {
      id: 'chap-thuan-do-cao',
      title: 'CHẤP THUẬN ĐỘ CAO TĨNH KHÔNG',
      subtitle: '03/2025',
      date: '03/2025',
      position: 'top',
      pdf: {
        filename:
          '5. QĐ 78 TC Chap thuan do cao tinh khong ngay 04.03.2025.pdf',
        title: 'QĐ 78 TC - Chấp thuận độ cao tĩnh không',
      },
    },
    {
      id: 'quy-hoach-500',
      title: 'QUY HOẠCH 1/500',
      subtitle: '06/2025',
      date: '06/2025',
      position: 'bottom',
      pdf: {
        filename:
          '6. QĐ 4041 Phe duyet do an dieu chinh 1-500 ngay 12.06.2025.pdf',
        title: 'QĐ 4041 - Phê duyệt đồ án điều chỉnh 1/500',
      },
    },
  ];

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    console.log('🚀 ~ PDFModal ~ pdfFile:', pdfFile);
  }, [pdfFile]);

  // Reset selected PDF when modal closes
  useEffect(() => {
    if (!isOpen) {
      setSelectedPDF(null);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleModalClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleTreeItemClick = (document) => {
    if (isMobile) {
      // Trên mobile: chỉ mở PDF trong tab mới, không thay đổi view
      window.open(`/pdf/${document.pdf.filename}`, '_blank');
    } else {
      // Trên desktop: hiển thị PDF trong modal
      setSelectedPDF(document.pdf);
    }
  };

  const handleBackToTree = () => {
    setSelectedPDF(null);
  };

  // Determine what to show: tree view, selected PDF, or single PDF
  // Trên mobile luôn hiển thị tree view khi showTreeView = true
  const showTree = showTreeView && (isMobile || !selectedPDF);
  const currentPDF = selectedPDF || pdfFile;
  const modalTitle = showTree ? '' : currentPDF?.title || 'Tài liệu PDF';

  return (
    <div
      className="pdf-modal"
      onClick={handleModalClick}
      style={{
        width: `${
          document.body.classList.contains('menu-open') && !isMobile
            ? 'calc(100vw - 260px)'
            : '100vw'
        }`,
        height: `${isMobile ? 'calc(100dvh - 50px)' : '100dvh'}`,
      }}
    >
      <div
        className={`pdf-modal__container ${
          showTree ? 'pdf-modal__container--tree' : ''
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="pdf-modal__header">
          <div className="pdf-modal__header-left">
            {selectedPDF && showTreeView && !isMobile && (
              <button
                className="pdf-modal__back-btn"
                onClick={handleBackToTree}
                title="Quay lại danh sách"
              >
                <i className="fa fa-arrow-left"></i>
              </button>
            )}
            <h2>{modalTitle}</h2>
          </div>
          {/* <div className="pdf-modal__header-actions">
            <button className="pdf-modal__close" onClick={onClose}>
              ×
            </button>
          </div> */}
        </div>
        <div className="pdf-modal__content">
          {showTree ? (
            <div className="pdf-modal__timeline-content">
              <div className="pdf-modal__timeline-header">
                <div className="logo">
                  <img
                    src="/assets/khp-images/tour/e055c252-77cb-488d-a256-4a2c0fc46cf2.jpg"
                    alt="logo"
                  />
                </div>
                <h2 className="timeline-subtitle">PHÁP LÝ DỰ ÁN</h2>
              </div>

              <div
                className={`pdf-modal__timeline ${isMobile ? 'mobile' : ''}`}
              >
                <div className="timeline-line">
                  <div className="timeline-arrow"></div>
                </div>

                <div className="timeline-items">
                  {legalDocuments.map((document, index) => (
                    <div
                      key={document.id}
                      className={`timeline-item ${document.position}`}
                      onClick={() => handleTreeItemClick(document)}
                    >
                      <div className="timeline-point">
                        <div className="timeline-dot"></div>
                      </div>

                      <div className="timeline-content">
                        <div className="timeline-text">
                          <h3>{document.title}</h3>
                          {document.subtitle && (
                            <span className="timeline-date">
                              {document.subtitle}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : currentPDF ? (
            <iframe
              src={`/pdf/${currentPDF.filename}`}
              title={currentPDF.title}
              width="100%"
              height="100%"
              frameBorder="0"
              allow="fullscreen"
            />
          ) : (
            <div className="pdf-modal__no-content">
              <p>Không có tài liệu để hiển thị</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PDFModal;
